module.exports = __webpack_public_path__ + "media/public/images/auth/bg-0f451abf576304b4804d19b20e021f12.jpg";